import React from 'react';
import { useCapabilities } from '../../Shared/capabilities';
import { useHeaderExtensions } from '../../Shared/headerExtensions';
import styles from './HeaderExtensionsList.module.scss';

const HeaderExtensionsList = ({ onItemClick }) => {
  const capabilities = useCapabilities();
  const extensions = useHeaderExtensions();

  const visibleExtensions = extensions.filter(
    (ext) => !ext.capability || capabilities[ext.capability]
  );

  if (visibleExtensions.length === 0) return null;

  return (
    <>
      {visibleExtensions.map((ext) => (
        <button
          key={ext.id}
          className={styles.extensionButton}
          onClick={(e) => {
            e.preventDefault();
            ext.onClick();
            if (onItemClick) onItemClick();
          }}
          type="button"
        >
          {ext.label}
        </button>
      ))}
    </>
  );
};

export default HeaderExtensionsList;
